<template>
    <b-modal
        :id="modalId"
        v-model="openModal"
        class="modal-demo"
        title-class="text-light"
        header-bg-variant="dark"
        header-text-variant="light"
        title-tag="h4"
        size="huge"
        :hide-footer="true"
        @show="openModalHandler"
        @hide="hideModal"
    >
        <template #modal-title>
            H-calculations:
        </template>

        <div class="p-4 modal-body">
            <div class="pb-4">
                <iframe height="100%" width="100%" :src="`${path}`"></iframe>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    props: {
        modalId: {
            type: String,
            required: false,
            default: 'hCalculationsPdfModal'
        },
        isOpen: {
            type: Boolean,
            default: false
        },
        path: { type: String, default: '' }
    },

    data() {
        return {
            openModal: false
        };
    },

    watch: {
        isOpen() {
            this.openModal = this.isOpen;
        }
    },

    methods: {
        hideModal() {
            this.$bvModal.hide(this.modalId);
            this.$emit('close');

            this.results = [];
        },

        async openModalHandler() {
            this.results = this.calculationRequestResults
                ? this.calculationRequestResults
                : [];
        }
    }
};
</script>
<style scoped>
div {
    width: 100%;
    height: 79vh;
    min-width: 400px;
}
</style>
